export const formatPhone = (value: string | null | undefined) => {
  if (!value) return '—';
  const digits = value.replace(/\D/g, '');
  const trimmed =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (trimmed.length === 10) {
    return `+1 (${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
  }

  return value.startsWith('+') ? value : `+${value}`;
};

export const concatWithEllipsis = (value: string, maxLength = 100) => {
  if (value.length <= maxLength) return value;
  return value.split('').slice(0, maxLength).join('') + '... ';
};
